import { Fragment } from 'react';

import { Analytics } from '@trello/atlassian-analytics';
import { forTemplate } from '@trello/legacy-i18n';
import { showFlag } from '@trello/nachos/experimental-flags';
import type { PIIString } from '@trello/privacy';
import type { TeamTestIds } from '@trello/test-ids';
import { getTestId } from '@trello/test-ids';

const format = forTemplate('workspace_invite');

const reportClickEvent = () => {
  Analytics.sendClickedLinkEvent({
    source: 'workspaceInviteModal',
    linkName: 'workspaceInviteModalError',
  });
};

export const getDescription = (
  members: (PIIString | string)[],
  newLicenseInviteRestrictUrl: string | null | undefined,
) => {
  return (
    <div>
      {members?.length > 1 && (
        <div>
          {members.map((member, index) => (
            // eslint-disable-next-line @eslint-react/no-array-index-key
            <Fragment key={index}>
              {member}
              <br />
            </Fragment>
          ))}
          <br />
        </div>
      )}
      <div>{format('error-unauthorized-description')}</div>
      {newLicenseInviteRestrictUrl && (
        <>
          <br />
          <a
            href={newLicenseInviteRestrictUrl}
            onClick={reportClickEvent}
            target="_blank"
            data-testid={getTestId<TeamTestIds>('team-invite-error-link')}
          >
            {format('request-access-link')}
          </a>
        </>
      )}
    </div>
  );
};

export function ShowNewLicenseInviteErrFlag(
  members: (PIIString | string)[],
  workspaceId: string,
  newLicenseInviteRestrictUrl: string | null | undefined,
) {
  const title =
    members?.length === 1
      ? format('error-unauthorized-invite', {
          user: members[0],
        })
      : format('error-unauthorized-invite-many');
  const description = getDescription(members, newLicenseInviteRestrictUrl);
  Analytics.sendTrackEvent({
    action: 'failed',
    actionSubject: 'workspaceInvitation',
    source: 'workspaceInviteModal',
    containers: {
      workspace: {
        id: workspaceId,
      },
    },
    attributes: {
      numInvited: members.length,
    },
  });
  showFlag({
    id: 'WorkspaceInviteModalError',
    seed:
      members.join() +
      '-' +
      'Unauthorized to grant licenses to non-enterprise members',
    title,
    description,
    appearance: 'error',
    isAutoDismiss: false,
    msTimeout: 8000,
  });
}
